import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restorePackage } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useRestorePackage = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restorePkg,
        isPending: isRestore,
    } = useMutation({
        mutationFn: restorePackage,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore package");
        },
    });

    return {
        restorePkg,
        isRestore,
    };
};

export default useRestorePackage;
